import LOGO_PREIN from '../_img/logo_prein_black.png'

// PREIN静岡テスト環境
export const URL_BASE='https://drone-shizuoka-city.prein.jp/'
export const AWS_S3_BUCKET_NAME='prod-drone-shizuoka-contents'
export const COPYRIGHT_TEXT ='© Inspiration.Plus'
export const BASE_BG_COLOR ='white'
export const BASE_FONT_COLOR ='black'
export const BASE_BORDER_COLOR ='#D0D0CE'
export const MENU_BG_COLOR ='#F2F2F2'
export const LOGO_IMG = LOGO_PREIN
export const SERVICE_NAME = 'PREIN'
export const DEFAULT_LAT = 34.9769440
export const DEFAULT_LNG = 138.3830570
export const MANUAL = 'prein_drone_manual_ver1.pdf'
export const SERVICE_TOP_URL = ''
export const RISK_URL = 'https://risk.prein.jp'
export const ARCHIVE_SITE_URL = ''
export const DASHBOARD_URL = 'https://prein.jp10.hcs.cloud.sap/link/prein-shizuoka'  